import React, { useState, useEffect } from 'react'
import InputAddress from 'v3/components/InputAddress';
import { Card, Select, Text, Input } from 'v3/components';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchCountries, fetchCities } from 'utils/fetches';

import {
  HOME_TYPES,
  ADDRESS_TYPES,
} from 'v3/utils/masks';

const Address = ({ data, setData, errors }) => {

  const isRequired = !!(data?.address && data.address.trim());
  const requiredMark = isRequired ? ' *' : '';

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetchCountries().then(setCountries);
  }, []);

  useEffect(() => {
    if (!data?.country) {
      const brazil = countries.find(country => country.abbreviation === 'br');
      setData({ ...data, country: brazil });
    }
  }, [countries]);

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Endereço
        </Text>
      }
    >
      <Row className="form">
        <Col xl={6} lg={6} md={12} xs={12}>
          <Select
            label={`País${requiredMark}`}
            options={countries}
            value={data?.country}
            onChange={value => setData({ ...data, country: value })}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            disableClear
            error={errors?.['driverAddress.country']}
          />
        </Col>
        <Col xl={12} lg={12} md={12} xs={12}>
          <InputAddress
            label={`Endereço${requiredMark}`}
            value={data?.address}
            onSelectedAddress={place => {
              setData({
                ...data,
                address: place?.address ? place.address : null,
                neighborhood: place?.neighborhood ? place.neighborhood : null,
                city: place?.city ? {
                  id: place.city_id,
                  name: place.city,
                  ibgeCode: place.city_ibge_code,
                  province: {
                    uf: place.province,
                    name: place.province_name
                  }
                } : null,
                province: place?.province ? {
                  uf: place.province,
                  name: place.province_name,
                  ibgeCode: place.province_ibge_code,
                } : null,
                cep: place?.zip_code ? place.zip_code : null,
                lat: place?.lat ? place.lat : null,
                lng: place?.lng ? place.lng : null,
                number: place?.number ? place.number : null,
              });
            }}
            country={data?.country?.abbreviation}
            onChange={e => {
              const newAddress = e.target.value;
              if (!newAddress || !newAddress.trim()) {
                setData({
                  ...data,
                  address: null,
                  neighborhood: null,
                  city: null,
                  province: null,
                  cep: null,
                  number: null,
                  complement: null,
                  addressType: null,
                  homeType: null,
                  lat: null,
                  lng: null,
                });
              } else {
                setData({ ...data, address: newAddress });
              }
            }}
            placeholder="Procurar endereço"
            error={errors?.['driverAddress.address']}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label={`Número${requiredMark}`}
            value={data?.number ?? ''}
            onChange={event => setData({ ...data, number: event.target.value })}
            error={errors?.['driverAddress.number']}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label="Complemento"
            value={data?.complement ?? ''}
            onChange={event => setData({ ...data, complement: event.target.value })}
            error={errors?.['driverAddress.complement']}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label={`Bairro${requiredMark}`}
            value={data?.neighborhood ?? ''}
            onChange={event =>
              setData({ ...data, neighborhood: event.target.value })
            }
            error={errors?.['driverAddress.neighborhood']}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12}>
          <Input
            label={`CEP${requiredMark}`}
            value={data?.cep ?? ''}
            onChange={event => setData({ ...data, cep: event.target.value })}
            error={errors?.['driverAddress.cep']}
          />
        </Col>

        <Col xl={6} lg={6} md={12} xs={12}>
          <Select.Async
            label={`Cidade${requiredMark}`}
            onSearch={fetchCities}
            value={data?.city}
            onChange={value => {
              setData({
                ...data,
                city: value,
                province: value ? value.province : null,
              });
            }}
            getOptionLabel={option =>
              `${option.name}, ${option.province.uf}`
            }
            getOptionValue={option =>
              `${option.name}, ${option.province.uf}`
            }
            error={errors?.['driverAddress.city'] || errors?.['driverAddress.province']}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12} className="mb-3">
          <Select
            label="Tipo de Moradia"
            value={data?.homeType}
            onChange={event => {
              setData({ ...data, homeType: event });
            }}
            options={HOME_TYPES}
            getOptionValue={option => option.label}
            error={errors?.['driverAddress.homeType']}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12} className="mb-3"><Select
          label={`Tipo de Endereço${requiredMark}`}
          value={data?.addressType}
          onChange={event => {
            setData({ ...data, addressType: event });
          }}
          options={ADDRESS_TYPES}
          getOptionValue={option => option.label}
          error={errors?.['driverAddress.addressType']}
        />
        </Col>
      </Row>
    </Card>
  )
}


export default Address
